<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    />
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editVendor="selectedvendor"
    />

    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(3)"
        title="Vendor"
        @add="add"
        :color="$style.purchase.titlebar"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            autofocus
            single-line
            hide-details
            clearable
          />
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="vendors"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td
                class="text-left"
                @click="viewProfile(item)"
                v-html="$highlight(item.name, search.toLowerCase())"
              >
                {{ item.name }}
              </td>
              <td
                class="text-left"
                @click="viewProfile(item)"
                v-html="$highlight(item.phoneNumber, search.toLowerCase())"
              >
                {{ item.phoneNumber }}
              </td>
              <td
                class="text-left"
                @click="viewProfile(item)"
                v-html="$highlight(item.email, search.toLowerCase())"
              >
                {{ item.email }}
              </td>
              <td class="text-right" @click="viewProfile(item)">
                {{ item.balance | currency }}
              </td>
              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item
                      v-if="checkRightStatus(19)"
                      @click="viewProfile(item)"
                    >
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item
                      v-if="checkRightStatus(19)"
                      @click="edit(item)"
                    >
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="checkRightStatus(11)"
                      @click="deletevendor(item)"
                    >
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <template v-slot:body.append="{ headers }" v-if="vendors.length > 0">
            <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td
                :colspan="headers.length - 2"
                class="text-right font-weight-bold"
              >
                List Total
              </td>
              <td class="text-right font-weight-bold">
                {{ balance | currency }}
              </td>
              <td></td>
            </tr>
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td
                :colspan="headers.length - 2"
                class="text-right font-weight-bold"
              >
                Result Total
              </td>
              <td class="text-right font-weight-bold">
                {{ fullBalance | currency }}
              </td>
              <td></td>
            </tr>
          </template>

          <!-- <template v-slot:body.append="{ headers }" v-if="vendors.length > 0">
            <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td
                :colspan="headers.length - 2"
                class="text-right font-weight-bold"
              >
                List Total
              </td>
              <td class="text-right font-weight-bold">
                {{ balance | currency }}
              </td>
              <td></td>
            </tr>
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td
                :colspan="headers.length - 2"
                class="text-right font-weight-bold"
              >
                Result Total
              </td>
              <td class="text-right font-weight-bold">
                {{ fullBalance | currency }}
              </td>
              <td></td>
            </tr>
          </template> -->

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import vendorService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

import _ from "lodash";

export default {
  name: "vendor-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedvendor: null,
      balance: 0,
      fullBalance: 0,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Phone Number",
          align: "left",
          value: "phoneNumber",
          sortable: true,
        },
        { text: "Email Address", value: "email", sortable: true },
        { text: "Balance", value: "balance", sortable: true },
        { text: "", value: "action", sortable: false },
      ],
      vendors: [],
      search: "",
      loading: true,
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
    };
  },
  created() {
    this.getList();
    document.title = "smplsale - Vendor List";
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
    search: _.debounce(function () {
      this.getList();
    }, 400),
  },
  components: { Create, Edit },
  methods: {
    viewProfile(val) {
      this.$router.push({ path: `/inventory/vendor/${val.id}/profile` });
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    // updateBalance(val) {
    //   this.balance = val.reduce((sum, row) => sum + (row.balance || 0), 0);
    // },
    getList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;

      const where = {
        limit: itemsPerPage,
        offset,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };
      if (this.search) where.search = this.search;

      return vendorService.getAll(where).then((response) => {
        //  console.log('response', response)
        this.loading = false;
        this.totalItems = response.count || 0;
        this.vendors = response.data || [];
        this.balance = this.vendors.reduce(
          (sum, row) => sum + (row.balance || 0),
          0
        );
        this.fullBalance = response.totals?.balance || 0;
      });
    },
    edit(vendor) {
      this.selectedvendor = vendor;
      this.editDialog = !this.editDialog;
    },
    deletevendor(vendor) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          vendorService.delete(vendor.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "vendor has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>